import React, { useEffect, useRef, useState } from "react";
import "./App.less";
import { routes } from "./router/index";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Button, ConfigProvider, Message, Modal } from "@arco-design/web-react";
import ClientTabs from "@/stores/clientTabStore";
import { v4 as uuidv4 } from "uuid";
import WSContext from "./utils/wsContext";
import Cookies from "js-cookie";
import axios from "axios";
import ClientUpdate from "./stores/clientUpdate";
import { observer } from "mobx-react-lite";
import { IconClose, IconDoubleRight } from "@arco-design/web-react/icon";
import upgrade from "@/assets/images/upgrade.png";
import AgentStore from "./stores/agentLogin";
import { getAppConfig } from "./services/login";
function App() {
  const router = createBrowserRouter(routes);
  const [clickCount, setClickCount] = useState(0);
  const [progress, setProgress] = useState<number>(0);
  const [upgradeVisible, setUpgradeVisible] = useState<boolean>(false);
  const [version, setVersion] = useState<string>("");
  const [taskId, setTaskId] = useState([]);

  const wsRef = useRef(null);
  const timerRef = useRef(null);
  const maxTaskLength = 5;

  const connectWebSocket = async () => {
    console.log("connectWebSocket----------------");

    const client_id = await window.electron.ipcRenderer.getSystemInfo();
    let location = "";
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          location = `${latitude},${longitude}`;
        },
        (err) => {
          console.log(err.message, "geolocation-error");
        }
      );
    } else {
      console.log("浏览器不支持");
    }
    const isAgent = AgentStore?.agent_info?.token ? true : false;
    // 创建 WebSocket 连接
    const token = isAgent
      ? localStorage.getItem("agent_token")
      : localStorage.getItem("Token");
    if (!token) {
      ClientTabs.setIsLive(false);
      setTimeout(connectWebSocket, 3000);
      return;
    }
    if (wsRef.current) return;
    wsRef.current = new WebSocket(
      `${process.env.REACT_APP_WS}/api/v1/video/task/ws${isAgent ? "/agent" : ""}?client_id=${client_id}&Token=${token}&position=${location}&aid=1005`
    );
    wsRef.current.onopen = () => {
      window.electron.log(
        `WebSocket 连接成功 client_id=${client_id},Token=${token}`
      );
      setTaskId([]);
      ClientTabs.setIsLive(true);
      // 启动心跳检测
      // startHeartbeat();
    };

    wsRef.current.onmessage = (event) => {
      // 解析收到的消息
      const data = event.data;
      window.electron.log(`ws.onmessage: ${data}`);
      const res = JSON.parse(data);
      const item = JSON.parse(res.body);
      const task = {
        ...res,
        body: { ...item, topic: item.topic ? JSON.parse(item.topic) : null },
        id: uuidv4(),
      };
      console.log(task, "task-detail");
      switch (task.method) {
        case 201:
          publishTask(task);
          setTaskId((prevTaskId) => [...prevTaskId, item.id]);
          break;
        case 202:
          accountTask(task);
          break;
        case 203:
          videoTask(task);
          break;
        default:
          break;
      }
    };

    wsRef.current.onclose = () => {
      window.electron.log(
        `WebSocket 连接关闭，尝试重连 client_id=${client_id},Token=${token}`
      );
      ClientTabs.setIsLive(false);
      // 断线后 3 秒重新连接
      setTimeout(connectWebSocket, 3000);
    };

    wsRef.current.onerror = (error) => {
      window.electron.log(`WebSocket 错误:  ${JSON.stringify(error)}`);
      ClientTabs.setIsLive(false);
    };
  };

  const publishTask = async (item) => {
    const res = await window.electron.ipcRenderer.videoPublish({
      data: item.body,
      isWatch: true,
    });
    if (!res) return;
    const status = res.code === "success" ? 2 : 3;
    const message = res.code === "success" ? "" : res.msg;
    const isSuccess = res.code === "success";
    const parsedMsg = isSuccess ? JSON.parse(res.msg) : {};
    getTask(102, {
      job_id: res.job_id,
      status: status,
      message: message,
      publish_at: res?.publish_at || 0,
      third_vid: parsedMsg.id,
      cron: res?.cron || undefined,
      link: parsedMsg.link || "",
      cover: parsedMsg.cover || "",
    });
    if (res.code !== "success") {
      Message.error(res.msg);
    }
  };
  const accountTask = async (item) => {
    const cookie = JSON.parse(item.body.auth_data).cookie;
    const platformUrls = {
      1: "https://creator.douyin.com/web/api/media/user/info/",
      3: "https://channels.weixin.qq.com/cgi-bin/mmfinderassistant-bin/auth/auth_data",
      4: "https://creator.xiaohongshu.com/api/galaxy/creator/home/personal_info",
    };
    const platformHeaders = {
      1: { cookie },
      3: { cookie },
      4: { cookie, referer: "https://creator.xiaohongshu.com/new/home" },
    };

    const url = platformUrls[item.body.platform];
    const headers = platformHeaders[item.body.platform];

    if (!url || !headers) return;

    let result,
      fans_num = 0,
      like_num = 0;
    try {
      result = await window.electron.ipcRenderer.getAccountRequest({
        url,
        headers,
        method: item.body.platform === 3 ? "POST" : "GET",
      });
    } catch (error) {
      console.error(
        `Error fetching data for platform ${item.body.platform}:`,
        error
      );
      return;
    }

    switch (item.body.platform) {
      case 1:
        fans_num = result?.user?.follower_count || 0;
        like_num = result?.user?.total_favorited || 0;
        break;
      case 3:
        fans_num = result?.data?.finderUser?.fansCount || 0;
        like_num = result?.data?.finderUser?.feedsCount || 0;
        break;
      case 4:
        fans_num = result?.data?.fansCount || 0;
        like_num = 0;
        break;
      default:
        break;
    }

    getTask(103, {
      account_id: item.body.account_id,
      fans_num: Number(fans_num),
      like_num: Number(like_num),
    });
  };

  const videoTask = async (item) => {
    const cookie = JSON.parse(item.body.auth_data).cookie;
    const { platform, earliest_time, account_id } = item.body;

    const platformsConfig = {
      1: {
        url: "https://creator.douyin.com/janus/douyin/creator/pc/work_list",
        params: {
          status: 1,
          count: 12,
          max_cursor: 0,
          scene: "star_atlas",
          device_platform: "android",
          aid: 1128,
        },
      },
      3: {
        url: "https://channels.weixin.qq.com/cgi-bin/mmfinderassistant-bin/post/post_list",
        params: {
          pageSize: 5,
          currentPage: 1,
        },
      },
      4: {
        url: "https://edith.xiaohongshu.com/web_api/sns/v5/creator/note/user/posted",
        headers: {
          referer: "https://creator.xiaohongshu.com/new/note-manager",
        },
        params: {
          tab: 1,
          page: 0,
        },
      },
      6: {
        url: "https://member.bilibili.com/x/web/archives",
        headers: {
          referer: "https://member.bilibili.com/platform/upload-manager/opus",
        },
        params: {
          status: "pubed",
          pn: 1,
          ps: 10,
          coop: 1,
          interactive: 1,
        },
      },
      7: {
        url: "https://mp.toutiao.com/api/feed/mp_provider/v1/?",
        headers: {
          referer: "https://mp.toutiao.com/profile_v4/xigua/content-manage-v2",
        },
        params: {
          provider_type: "mp_provider",
          aid: 13,
          app_name: "news_article",
          category: "mp_all",
          channel: "",
          stream_api_version: 88,
          genre_type_switch: JSON.stringify({
            repost: 1,
            small_video: 1,
            toutiao_graphic: 1,
            weitoutiao: 1,
            xigua_video: 1,
          }),
          device_platform: "pc",
          platform_id: 0,
          visited_uid: 855850700013376,
          offset: 0,
          count: 10,
          client_extra_params: JSON.stringify({
            category: "mp_videos",
            real_app_id: "1231",
            need_forward: "true",
            offset_mode: "1",
            page_index: "1",
            status: "0",
            source: "all",
          }),
          app_id: 1231,
        },
      },
      8: {
        url: "https://baijiahao.baidu.com/pcui/article/lists",
        params: {
          currentPage: 1,
          pageSize: 10,
          clearBeforeFetch: false,
          dynamic: false,
        },
      },
    };

    const platformConfig = platformsConfig[platform];

    if (!platformConfig) {
      return;
    }

    const headers = { cookie, ...(platformConfig.headers || {}) };
    const result = await window.electron.ipcRenderer.getVideoTaskRequest({
      platform,
      url: platformConfig.url,
      headers,
      params: platformConfig.params,
      earliest_time,
    });

    console.log("videoTask-------------->", result);

    getTask(104, {
      account_id,
      items: result,
    });
  };
  const checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };
  // 空闲 获取任务
  // 发送消息并记录日志的辅助函数
  const sendMessage = (method, body?) => {
    wsRef.current.send(JSON.stringify({ method, body: JSON.stringify(body) }));
    if (method !== 101) {
      if (method == 102) {
        setTaskId((prevTaskId) => prevTaskId.filter((id) => id != body.job_id));
      }
      if (window.electron?.log) {
        window.electron.log(`ws.send: ${JSON.stringify({ method, body })}`);
      }
    }
  };
  // 空闲 获取任务
  const getTask = (method, body?) => {
    switch (method) {
      case 101:
        sendMessage(101);
        break;

      case 102:
      case 103:
      case 104:
        sendMessage(method, body);
        break;

      default:
        break;
    }
  };
  const handleOpenFolder = () => {
    setClickCount((prevCount) => prevCount + 1);
  };
  const getClientVersion = async () => {
    if (window?.electron?.ipcRenderer?.getVersion) {
      const res = await window.electron.ipcRenderer?.getVersion();
      setVersion(res);
    }
  };
  const handleCheckUpdate = async () => {
    if (window.electron && window.electron.ipcRenderer.getCheckUpdateStatus) {
      const res = await window.electron.ipcRenderer.getCheckUpdateStatus();
      if (res) {
        ClientUpdate.setUpdateInfo(res);
      }
      window.electron.ipcRenderer.getUpdateProgress((progress) => {
        setProgress(progress);
      });
    }
  };
  const handleKeyDown = (event) => {
    // 判断是否按下 Ctrl+R 或 Cmd+R（macOS）
    if (
      (event.ctrlKey || event.metaKey) &&
      event.key.toLowerCase() === "r" &&
      progress
    ) {
      event.preventDefault(); // 阻止默认的刷新行为
    }
  };
  // 初始化连接
  useEffect(() => {
    ClientTabs.updateIsClient(window && window.electron);
    if (window.electron) {
      handleCheckUpdate();
      connectWebSocket();
      window.electron?.ipcRenderer.on("wasm-log", (data) => {
        ClientTabs.addLog(data);
      });
      window.electron?.ipcRenderer.on("publishTask", (res) => {
        const status = res.code === "success" ? 2 : 3;
        const message = res.code === "success" ? "" : res.msg;
        const isSuccess = res.code === "success";
        const parsedMsg = isSuccess ? JSON.parse(res.msg) : {};
        getTask(102, {
          job_id: res.job_id,
          status: status,
          message: message,
          publish_at: res?.publish_at || 0,
          third_vid: parsedMsg.id,
          cron: res?.cron || undefined,
          link: parsedMsg.link || "",
          cover: parsedMsg.cover || "",
        });
        if (res.code !== "success") {
          Message.error(res.msg);
        }
      });
      console.log("xxxxxxxxxxx", window.electron?.ipcRenderer?.getConfig);

      // window.electron?.ipcRenderer?.getConfig().then((config) => {
      //   console.log("appp config ", config);
      //   if (config.mode === "pro") {
      document.addEventListener("keydown", (event) => {
        // 禁用 Ctrl+R (Windows/Linux) 或 Cmd+R (Mac)
        if ((event.ctrlKey || event.metaKey) && event.key === "r") {
          event.preventDefault();
          return false;
        }
        // 禁用 F5
        if (event.key === "F5") {
          event.preventDefault();
          return false;
        }
      });
      // }
      // });
    }
    getClientVersion();
    return () => {
      if (wsRef.current) {
        wsRef.current.close(); // 组件卸载时关闭 WebSocket 连接
      }
    };
  }, []);
  useEffect(() => {
    // 如果不在 Electron 环境或 WebSocket 未就绪，直接返回
    if (!window.electron || !wsRef.current) return;

    // 只有在 taskId 数量 <= 3 且还没有定时器时，才启动
    if (taskId.length < 3 && timerRef.current === null) {
      timerRef.current = setInterval(() => {
        getTask(101);
      }, 2000);
    }
    // 如果 taskId 数量 > 3 且定时器存在，则清除
    else if (taskId.length >= 3 && timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    // 卸载或依赖变化时的清理
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [wsRef.current, taskId.length]);
  useEffect(() => {
    // 添加键盘事件监听
    if (progress == 100) {
      setTimeout(() => {
        setUpgradeVisible(false);
        window.removeEventListener("keydown", handleKeyDown);
      }, 1500);
    } else if (progress != 0 && progress != 100) {
      window.addEventListener("keydown", handleKeyDown);
    }
    // 清理监听
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [progress]);
  // 当点击次数达到5次时，打开日志文件夹
  useEffect(() => {
    if (clickCount === 5) {
      // 打开文件夹
      if (window.electron && window.electron.ipcRenderer.openFolder) {
        window.electron.ipcRenderer.openFolder();
      }
      // 重置点击次数
      setClickCount(0);
    }
  }, [clickCount]);
  useEffect(() => {
    getAppConfig().then((res) => {
      AgentStore.updateAppConfig(res);
    });
  }, []);

  return (
    <div className="App">
      {/* <button onClick={() => {
        const res = {
          "method": 201,
          "body": "{\"id\":599562,\"task_id\":15257,\"title\":\"测试回执任务\",\"media_url\":\"https://xinghuo-dev-01.oss-cn-shanghai.aliyuncs.com/team-2/composition_human/202507/b20c0e20-8538-48f8-8cae-914ac419e9bc.mp4?Expires=1757668475\\u0026OSSAccessKeyId=STS.NZjrw4FM1f6JsEVA67NLpSC6b\\u0026Signature=n84HAKnBYJ8rbAJWthCbfZY8zrg%3D\\u0026security-token=CAIS2gJ1q6Ft5B2yfSjIr5nfOc2Aq5IQ0fShcWPnpTZiQsNcvIadgDz2IHhMfHBrAe8Wt%2Fg2n29R6foclrNyQJIAQEHIbMI1t8gNoFv4M9KQ5pbqveVZ1cUxzNZg90WpsvXJasDVEfn%2FGJ70GX2m%2BwZ3xbzlD0bAO3WuLZyOj7N%2Bc90TRXPWRDFaBdBQVGAAwY1gQhm3D%2Fu2NQPwiWf9FVdhvhEG6Vly8qOi2MaRmHG85R%2FYsrZJ%2FdWpe8j8PpQ2Y8cmDoqPsbYoJvab4kl58ANX8ap6tqtA9Arcs8uVa1sruE3ea7OPqoI%2FdVMgPfdjRPIatoTVkfxpp%2BryvKnbxhhEIOVJaSPbSZBJPQdeog1KXDxQV8EYWxylurjnXvF%2BI9i%2Byse6min%2B2svzhw6RGJ1dq8DgUNsD0npkDGktxWZ7Hl9YX%2BT7gVsGMzToQ3rLd9GztUC8Uou6SOR2X3Z%2BGoABSENwrVyoQ6ExSrNiQKVrGNnMzfR8Ta9PX6wEK%2F5uQC%2FpnfP06zdPS0hl7NRbu6hfc4cyjB7%2BT9Cq4tzoDcUPwDkIikov%2Fh45ZLh0n1GcPY0g4bU%2BDMRM08El6rY0AiVcvzuKGXjYuv%2BX7Q5%2F7Ids1FrsWJts8L6HGCALG9Qtm3ogAA%3D%3D\",\"cover_url\":\"https://xinghuo-dev-01.oss-cn-shanghai.aliyuncs.com/team-2/composition_human/202507/ice-generated/44b44480679871f0aa49f6f6c7496302/snapshots/normal/eec07b26bf0f490e9e4cc87a13bafaa3-00001.jpg?Expires=1757668475\\u0026OSSAccessKeyId=STS.NZjrw4FM1f6JsEVA67NLpSC6b\\u0026Signature=UqW75gxMDKl3IV%2BylrBkTaRQCuY%3D\\u0026security-token=CAIS2gJ1q6Ft5B2yfSjIr5nfOc2Aq5IQ0fShcWPnpTZiQsNcvIadgDz2IHhMfHBrAe8Wt%2Fg2n29R6foclrNyQJIAQEHIbMI1t8gNoFv4M9KQ5pbqveVZ1cUxzNZg90WpsvXJasDVEfn%2FGJ70GX2m%2BwZ3xbzlD0bAO3WuLZyOj7N%2Bc90TRXPWRDFaBdBQVGAAwY1gQhm3D%2Fu2NQPwiWf9FVdhvhEG6Vly8qOi2MaRmHG85R%2FYsrZJ%2FdWpe8j8PpQ2Y8cmDoqPsbYoJvab4kl58ANX8ap6tqtA9Arcs8uVa1sruE3ea7OPqoI%2FdVMgPfdjRPIatoTVkfxpp%2BryvKnbxhhEIOVJaSPbSZBJPQdeog1KXDxQV8EYWxylurjnXvF%2BI9i%2Byse6min%2B2svzhw6RGJ1dq8DgUNsD0npkDGktxWZ7Hl9YX%2BT7gVsGMzToQ3rLd9GztUC8Uou6SOR2X3Z%2BGoABSENwrVyoQ6ExSrNiQKVrGNnMzfR8Ta9PX6wEK%2F5uQC%2FpnfP06zdPS0hl7NRbu6hfc4cyjB7%2BT9Cq4tzoDcUPwDkIikov%2Fh45ZLh0n1GcPY0g4bU%2BDMRM08El6rY0AiVcvzuKGXjYuv%2BX7Q5%2F7Ids1FrsWJts8L6HGCALG9Qtm3ogAA%3D%3D\",\"publish_at\":1757664863,\"account_id\":24175,\"platform\":1,\"auth_data\":\"{\\\"cookie\\\":\\\"bd_ticket_guard_client_data_v2=eyJyZWVfcHVibGljX2tleSI6IkJETmpWRjVHdkNKSXlTZVUrS3I3RGtNMFJUNDNQd2tLYWVva1FNcThmalgxb3B6OVd4SE5YWDZzaDFkazZsT3ppdGFVNkY4OFFxYjA3NjZTa3JFYnM2bz0iLCJ0c19zaWduIjoidHMuMi40MzUzYzVhMmJmM2UzZjFhODk0OTFiZjAzNjlkOWE5MDg0MWZmOTZlMjIwNTRhZDllNmEzNGIzODcyN2NmYjUxYzRmYmU4N2QyMzE5Y2YwNTMxODYyNGNlZGExNDkxMWNhNDA2ZGVkYmViZWRkYjJlMzBmY2U4ZDRmYTAyNTc1ZCIsInJlcV9jb250ZW50Ijoic2VjX3RzIiwicmVxX3NpZ24iOiIwNFIwTTU2cVphZjR1Y3UwUkY0R1pqNTArazZQVkd4QVJ2UDBscVIxRnFRPSIsInNlY190cyI6IiNWV2lJaCtRZjVML1JaaThSNDV3eW82d1AwcUNlL2JpUnd3M0wvdzI4MUZ2ZnU2MktWYXA1bnlxYkhtUkoifQ%3D%3D; session_tlb_tag=sttt%7C19%7CjErZVPcWjBa9feIwCgLHNP_________73khoRFdHaSMfmPnT-A1sIKUVfvdbKc5hUxH7Ktf1I5g%3D; gd_random=eyJtYXRjaCI6dHJ1ZSwicGVyY2VudCI6MC4xMzcyNjQ1NDE0OTk0MTg1OH0=.fILRBHo9bNEeHblFIAQ0W4Z/WC0pBq/5e7UpWWeNv9k=; passport_assist_user=CkGr8pPsXa0v3PZ3OPCAVnvW83d_wmW9QLdaawBM-Dzc9A7lxfJuRlUIHD74NTcJ0b6LSHLAlOZBSwPZ9qGxFcnvGRpKCjwAAAAAAAAAAAAAT3eZp4gI1mkJYGyjxowqqvaEC42J6F0zYZ_BZf7U9lOsRBemE-K4QwGdHqbmQhQAM9gQof77DRiJr9ZUIAEiAQNzaMlC; gfkadpd=2906,33638; IsDouyinActive=false; FOLLOW_LIVE_POINT_INFO=%22MS4wLjABAAAALbi05Sx1wI60JzcydwwHn9YC0bEifQouTrmlb0ERV_BhzFQKrlJXwWAGdz7P97rw%2F1757692800000%2F0%2F1757664821411%2F0%22; odin_tt=6e8cdbc9e0d07379ea5cd94340bd4f1e75e9d45cc6d36a18740fd556f89a3144060f108007ef6d8725b142cb9507a2c6c08d6a26f941c9fb74bbefccca868e73; SelfTabRedDotControl=%5B%7B%22id%22%3A%227451962581972944930%22%2C%22u%22%3A89%2C%22c%22%3A0%7D%5D; biz_trace_id=2bf045c1; home_can_add_dy_2_desktop=%221%22; publish_badge_show_info=%220%2C0%2C0%2C1757664824091%22; UIFID=99405022e0708801aee7ff4c54400ac8e593ae85f3b433b0b452508931dcf94fea2524bc6731952d8daf211b5bb617c7173f2bcc9e35bed84cd68435d310e9c118e1090be7f4e671afa43c941e3f0e915ef59b195bc6b87c78458d31eea22eb469cab027ae11dbdda2897e414cb1e91187524ff57892fec7a4f052fc5e10208b544f6ea07fe914938d4cfe5c131d1e25eea9b76f6dfc2c1fd00e8349d36eca49; __security_server_data_status=1; is_staff_user=false; ttwid=1%7CF6dxWR1etJmiPxw0arUGR0xypQSbj_nk8lJ5jqqBYcU%7C1757664832%7Cc5f964e1a37c9b982256251d4c7b8a56bea625d4e8881017f29303a52f20033a; sessionid_ss=8c4ad954f7168c16bd7de2300a02c734; passport_csrf_token=bfcad739911645b4563d3711e82cc8bb; stream_player_status_params=%22%7B%5C%22is_auto_play%5C%22%3A0%2C%5C%22is_full_screen%5C%22%3A0%2C%5C%22is_full_webscreen%5C%22%3A0%2C%5C%22is_mute%5C%22%3A0%2C%5C%22is_speed%5C%22%3A1%2C%5C%22is_visible%5C%22%3A0%7D%22; passport_mfa_token=CjcSCfREru2L5icIgOrXlW2Uyd8DMjqPHl5whbSpoWH7pHbRbUh7pVpHMhbrkoIDUWVmEGlGSLSeGkoKPAAAAAAAAAAAAABPd82f0aY7wfbIeDj4X%2BLllWJKzftBm2EDTkVol%2FuRvY9TlSIkAgJUTR1u%2Bh92GolQPBCV%2FvsNGPax0WwgAiIBA%2B%2Bclic%3D; gulu_source_res=eyJwX2luIjoiZTBiNzA1NzgwZDUxMGU2MDhlNzEyM2YxMDgyMGE2YjEzOWU3OGMwMzkwY2NlMDQ2MDZlZWNmZjI5ZTBkNTJhYiJ9; sid_tt=8c4ad954f7168c16bd7de2300a02c734; __security_mc_1_s_sdk_cert_key=c04a8c33-46bf-94bd; enter_pc_once=1; passport_csrf_token_default=bfcad739911645b4563d3711e82cc8bb; bit_env=SExzgtNA60s8Rzhy-U9hlUXCII2pif0cf8r95YRSI0T3N3nBGvMN-HNQ_SIHPH6NjEAGE_YHmHxeIh3SUyFUfDQ4gSlyrVvawkY0pBuPeM61QrhDqJoKLf7b9u1-prlTxuFMmgD9lGb8Fn4F2wPt1Arxk1bdJUv809uWdD29Pwj2sTP1sA3XvMfv0LO37b5YULDouj3u1MZudj1rVTDEJwWqnfNuJDd4-y8irz_UST6tmVM-YB8uJHj0UvW_p16GWzsppcy__vciOOX3azYiMC94cZNWueHSinoUVr-JFXpEvf_cXjnsVyV2yL4Q7Gg782NIyFbl4rb9J18wUzyThS0RgWEhco_KNJVFAcXnoJoSNr72OurGJX9BeaSmxzJhrFCteFNeQn8V0xl9u0gHZrEKElWi_ImpO_hD1bkDQM4ae5Wewy6eFJs7oaBJeSkTlg3s_GvavoChVUJeqSyjErRQzynygOn3q6yZV8_Grb6hFp6HBESCtR_XPRCMRLWk; _tea_utm_cache_2906=undefined; sid_guard=8c4ad954f7168c16bd7de2300a02c734%7C1757664820%7C5184000%7CTue%2C+11-Nov-2025+08%3A13%3A40+GMT; n_mh=wTkCWHg3BOwt_k9BXhP-UYIi1Clo7NDFJhbzFvuaSbY; sessionid=8c4ad954f7168c16bd7de2300a02c734; bd_ticket_guard_client_data=eyJiZC10aWNrZXQtZ3VhcmQtdmVyc2lvbiI6MiwiYmQtdGlja2V0LWd1YXJkLWl0ZXJhdGlvbi12ZXJzaW9uIjoxLCJiZC10aWNrZXQtZ3VhcmQtcmVlLXB1YmxpYy1rZXkiOiJCRE5qVkY1R3ZDSkl5U2VVK0tyN0RrTTBSVDQzUHdrS2Flb2tRTXE4ZmpYMW9wejlXeEhOWFg2c2gxZGs2bE96aXRhVTZGODhRcWIwNzY2U2tyRWJzNm89IiwiYmQtdGlja2V0LWd1YXJkLXdlYi12ZXJzaW9uIjoyfQ%3D%3D; login_time=1757664820026; d_ticket=59af7ca5e5e7961f336155fd51501b8e494e7; passport_auth_mix_state=ljyf0r0p0uk70bzefowr9se90gu53ryhpcrxsqdjyj069hdm; sdk_source_info=7e276470716a68645a606960273f276364697660272927676c715a6d6069756077273f276364697660272927666d776a68605a607d71606b766c6a6b5a7666776c7571273f275e58272927666a6b766a69605a696c6061273f27636469766027292762696a6764695a7364776c6467696076273f275e592772606761776c7360775927582729277672715a646971273f2763646976602729277f6b5a666475273f2763646976602729276d6a6e5a6b6a716c273f2763646976602729276c6b6f5a7f6367273f27636469766027292771273f2736303534353d31333332303234272927676c715a75776a716a666a69273f2763646976602778; bd_ticket_guard_client_web_domain=2; csrf_session_id=078dd36374d2aa39b2e721ac2e798f00; stream_recommend_feed_params=%22%7B%5C%22cookie_enabled%5C%22%3Atrue%2C%5C%22screen_width%5C%22%3A1920%2C%5C%22screen_height%5C%22%3A1080%2C%5C%22browser_online%5C%22%3Atrue%2C%5C%22cpu_core_num%5C%22%3A16%2C%5C%22device_memory%5C%22%3A8%2C%5C%22downlink%5C%22%3A10%2C%5C%22effective_type%5C%22%3A%5C%224g%5C%22%2C%5C%22round_trip_time%5C%22%3A50%7D%22; UIFID_TEMP=99405022e0708801aee7ff4c54400ac8e593ae85f3b433b0b452508931dcf94f05733049c1e264de88fa5ab57c7b067c56bdd13c5904c97d9871033f9e531d396316d6915df90abcaabf2067e1398bb4; __security_mc_1_s_sdk_crypt_sdk=ccc9ea8e-48f0-a7ff; ssid_ucp_v1=1.0.0-KGY3YjdjZWJmYTZmZjAzOGNmM2E2ZGYyOWVhMWNkNjFjNGViZWI5MDkKIQi7kICpqs3UBBC0rI_GBhjvMSAMMO2lqaUGOAdA9AdIBBoCaGwiIDhjNGFkOTU0ZjcxNjhjMTZiZDdkZTIzMDBhMDJjNzM0; strategyABtestKey=%221757664799.199%22; x-web-secsdk-uid=77dd0a1d-9dd1-4910-8b12-9028c484945a; uid_tt=3650ce97ba804f6fe86dc160ccbe7c53; volume_info=%7B%22isUserMute%22%3Afalse%2C%22isMute%22%3Afalse%2C%22volume%22%3A0.5%7D; uid_tt_ss=3650ce97ba804f6fe86dc160ccbe7c53; _bd_ticket_crypt_cookie=9b8840301c0334749fbb70e4a13c2373; __security_mc_1_s_sdk_sign_data_key_web_protect=7a90ebdd-475c-9730; sid_ucp_v1=1.0.0-KGY3YjdjZWJmYTZmZjAzOGNmM2E2ZGYyOWVhMWNkNjFjNGViZWI5MDkKIQi7kICpqs3UBBC0rI_GBhjvMSAMMO2lqaUGOAdA9AdIBBoCaGwiIDhjNGFkOTU0ZjcxNjhjMTZiZDdkZTIzMDBhMDJjNzM0\\\",\\\"user_agent\\\":\\\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/139.0.0.0 Safari/537.36\\\",\\\"webviewId\\\":\\\"341cf14a-5356-4c1e-a95e-509daed057c0\\\",\\\"s_sdk_crypt_sdk\\\":{\\\"ec_privateKey\\\":\\\"-----BEGIN PRIVATE KEY-----\\\\nMIGHAgEAMBMGByqGSM49AgEGCCqGSM49AwEHBG0wawIBAQQgZMBDKWhNwLe9Ev7x79WhQ4UCI3C7eESkvGL+kdxGmEihRANCAAQzY1ReRrwiSMknlPiq+w5DNEU+Nz8JCmnqJEDKvH419aKc/VsRzV1+rIdXZOpTs4rWlOhfPEKm9O+ukpKxG7Oq\\\\n-----END PRIVATE KEY-----\\\",\\\"ec_publicKey\\\":\\\"-----BEGIN PUBLIC KEY-----\\\\nMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEM2NUXka8IkjJJ5T4qvsOQzRFPjc/CQpp6iRAyrx+NfWinP1bEc1dfqyHV2TqU7OK1pToXzxCpvTvrpKSsRuzqg==\\\\n-----END PUBLIC KEY-----\\\"},\\\"web_protect\\\":{\\\"ticket\\\":\\\"hash.A4FTmlt9459W2VuCPaUVVJ1CAhsh11nKDmNpfQGDN8s=\\\",\\\"ts_sign\\\":\\\"ts.2.4353c5a2bf3e3f1a89491bf0369d9a90841ff96e22054ad9e6a34b38727cfb51c4fbe87d2319cf05318624ceda14911ca406dedbebeddb2e30fce8d4fa02575d\\\",\\\"client_cert\\\":\\\"pub.BDNjVF5GvCJIySeU+Kr7DkM0RT43PwkKaeokQMq8fjX1opz9WxHNXX6sh1dk6lOzitaU6F88Qqb0766SkrEbs6o=\\\"},\\\"s_sdk_server_cert_key\\\":\\\"-----BEGIN CERTIFICATE-----\\\\nMIIEfTCCBCKgAwIBAgIUXWdS2tzmSoewCWfKFyiWMrJqs/0wCgYIKoZIzj0EAwIw\\\\nMTELMAkGA1UEBhMCQ04xIjAgBgNVBAMMGXRpY2tldF9ndWFyZF9jYV9lY2RzYV8y\\\\nNTYwIBcNMjIxMTE4MDUyMDA2WhgPMjA2OTEyMzExNjAwMDBaMCQxCzAJBgNVBAYT\\\\nAkNOMRUwEwYDVQQDEwxlY2llcy1zZXJ2ZXIwWTATBgcqhkjOPQIBBggqhkjOPQMB\\\\nBwNCAASE2llDPlfc8Rq+5J5HXhg4edFjPnCF3Ua7JBoiE/foP9m7L5ELIcvxCgEx\\\\naRCHbQ8kCCK/ArZ4FX/qCobZAkToo4IDITCCAx0wDgYDVR0PAQH/BAQDAgWgMDEG\\\\nA1UdJQQqMCgGCCsGAQUFBwMBBggrBgEFBQcDAgYIKwYBBQUHAwMGCCsGAQUFBwME\\\\nMCkGA1UdDgQiBCABydxqGrVEHhtkCWTb/vicGpDZPFPDxv82wiuywUlkBDArBgNV\\\\nHSMEJDAigCAypWfqjmRIEo3MTk1Ae3MUm0dtU3qk0YDXeZSXeyJHgzCCAZQGCCsG\\\\nAQUFBwEBBIIBhjCCAYIwRgYIKwYBBQUHMAGGOmh0dHA6Ly9uZXh1cy1wcm9kdWN0\\\\naW9uLmJ5dGVkYW5jZS5jb20vYXBpL2NlcnRpZmljYXRlL29jc3AwRgYIKwYBBQUH\\\\nMAGGOmh0dHA6Ly9uZXh1cy1wcm9kdWN0aW9uLmJ5dGVkYW5jZS5uZXQvYXBpL2Nl\\\\ncnRpZmljYXRlL29jc3AwdwYIKwYBBQUHMAKGa2h0dHA6Ly9uZXh1cy1wcm9kdWN0\\\\naW9uLmJ5dGVkYW5jZS5jb20vYXBpL2NlcnRpZmljYXRlL2Rvd25sb2FkLzQ4RjlD\\\\nMEU3QjBDNUE3MDVCOTgyQkU1NTE3MDVGNjQ1QzhDODc4QTguY3J0MHcGCCsGAQUF\\\\nBzAChmtodHRwOi8vbmV4dXMtcHJvZHVjdGlvbi5ieXRlZGFuY2UubmV0L2FwaS9j\\\\nZXJ0aWZpY2F0ZS9kb3dubG9hZC80OEY5QzBFN0IwQzVBNzA1Qjk4MkJFNTUxNzA1\\\\nRjY0NUM4Qzg3OEE4LmNydDCB5wYDVR0fBIHfMIHcMGygaqBohmZodHRwOi8vbmV4\\\\ndXMtcHJvZHVjdGlvbi5ieXRlZGFuY2UuY29tL2FwaS9jZXJ0aWZpY2F0ZS9jcmwv\\\\nNDhGOUMwRTdCMEM1QTcwNUI5ODJCRTU1MTcwNUY2NDVDOEM4NzhBOC5jcmwwbKBq\\\\noGiGZmh0dHA6Ly9uZXh1cy1wcm9kdWN0aW9uLmJ5dGVkYW5jZS5uZXQvYXBpL2Nl\\\\ncnRpZmljYXRlL2NybC80OEY5QzBFN0IwQzVBNzA1Qjk4MkJFNTUxNzA1RjY0NUM4\\\\nQzg3OEE4LmNybDAKBggqhkjOPQQDAgNJADBGAiEAqMjT5ADMdGMeaImoJK4J9jzE\\\\nLqZ573rNjsT3k14pK50CIQCLpWHVKWi71qqqrMjiSDvUhpyO1DpTPRHlavPRuaNm\\\\nww==\\\\n-----END CERTIFICATE-----\\\",\\\"s_sdk_cert_key\\\":\\\"pub.BDNjVF5GvCJIySeU+Kr7DkM0RT43PwkKaeokQMq8fjX1opz9WxHNXX6sh1dk6lOzitaU6F88Qqb0766SkrEbs6o=\\\",\\\"security-sdk/s_sdk_server_cert_key\\\":\\\"{\\\\\\\"cert\\\\\\\":\\\\\\\"-----BEGIN CERTIFICATE-----\\\\\\\\nMIIEfTCCBCKgAwIBAgIUXWdS2tzmSoewCWfKFyiWMrJqs/0wCgYIKoZIzj0EAwIw\\\\\\\\nMTELMAkGA1UEBhMCQ04xIjAgBgNVBAMMGXRpY2tldF9ndWFyZF9jYV9lY2RzYV8y\\\\\\\\nNTYwIBcNMjIxMTE4MDUyMDA2WhgPMjA2OTEyMzExNjAwMDBaMCQxCzAJBgNVBAYT\\\\\\\\nAkNOMRUwEwYDVQQDEwxlY2llcy1zZXJ2ZXIwWTATBgcqhkjOPQIBBggqhkjOPQMB\\\\\\\\nBwNCAASE2llDPlfc8Rq+5J5HXhg4edFjPnCF3Ua7JBoiE/foP9m7L5ELIcvxCgEx\\\\\\\\naRCHbQ8kCCK/ArZ4FX/qCobZAkToo4IDITCCAx0wDgYDVR0PAQH/BAQDAgWgMDEG\\\\\\\\nA1UdJQQqMCgGCCsGAQUFBwMBBggrBgEFBQcDAgYIKwYBBQUHAwMGCCsGAQUFBwME\\\\\\\\nMCkGA1UdDgQiBCABydxqGrVEHhtkCWTb/vicGpDZPFPDxv82wiuywUlkBDArBgNV\\\\\\\\nHSMEJDAigCAypWfqjmRIEo3MTk1Ae3MUm0dtU3qk0YDXeZSXeyJHgzCCAZQGCCsG\\\\\\\\nAQUFBwEBBIIBhjCCAYIwRgYIKwYBBQUHMAGGOmh0dHA6Ly9uZXh1cy1wcm9kdWN0\\\\\\\\naW9uLmJ5dGVkYW5jZS5jb20vYXBpL2NlcnRpZmljYXRlL29jc3AwRgYIKwYBBQUH\\\\\\\\nMAGGOmh0dHA6Ly9uZXh1cy1wcm9kdWN0aW9uLmJ5dGVkYW5jZS5uZXQvYXBpL2Nl\\\\\\\\ncnRpZmljYXRlL29jc3AwdwYIKwYBBQUHMAKGa2h0dHA6Ly9uZXh1cy1wcm9kdWN0\\\\\\\\naW9uLmJ5dGVkYW5jZS5jb20vYXBpL2NlcnRpZmljYXRlL2Rvd25sb2FkLzQ4RjlD\\\\\\\\nMEU3QjBDNUE3MDVCOTgyQkU1NTE3MDVGNjQ1QzhDODc4QTguY3J0MHcGCCsGAQUF\\\\\\\\nBzAChmtodHRwOi8vbmV4dXMtcHJvZHVjdGlvbi5ieXRlZGFuY2UubmV0L2FwaS9j\\\\\\\\nZXJ0aWZpY2F0ZS9kb3dubG9hZC80OEY5QzBFN0IwQzVBNzA1Qjk4MkJFNTUxNzA1\\\\\\\\nRjY0NUM4Qzg3OEE4LmNydDCB5wYDVR0fBIHfMIHcMGygaqBohmZodHRwOi8vbmV4\\\\\\\\ndXMtcHJvZHVjdGlvbi5ieXRlZGFuY2UuY29tL2FwaS9jZXJ0aWZpY2F0ZS9jcmwv\\\\\\\\nNDhGOUMwRTdCMEM1QTcwNUI5ODJCRTU1MTcwNUY2NDVDOEM4NzhBOC5jcmwwbKBq\\\\\\\\noGiGZmh0dHA6Ly9uZXh1cy1wcm9kdWN0aW9uLmJ5dGVkYW5jZS5uZXQvYXBpL2Nl\\\\\\\\ncnRpZmljYXRlL2NybC80OEY5QzBFN0IwQzVBNzA1Qjk4MkJFNTUxNzA1RjY0NUM4\\\\\\\\nQzg3OEE4LmNybDAKBggqhkjOPQQDAgNJADBGAiEAqMjT5ADMdGMeaImoJK4J9jzE\\\\\\\\nLqZ573rNjsT3k14pK50CIQCLpWHVKWi71qqqrMjiSDvUhpyO1DpTPRHlavPRuaNm\\\\\\\\nww==\\\\\\\\n-----END CERTIFICATE-----\\\\\\\",\\\\\\\"sn\\\\\\\":\\\\\\\"533240336124694022040808462028007165443034493949\\\\\\\",\\\\\\\"createdTime\\\\\\\":1757664832299}\\\",\\\"security-sdk/s_sdk_cert_key\\\":\\\"{\\\\\\\"data\\\\\\\":\\\\\\\"pub.BDNjVF5GvCJIySeU+Kr7DkM0RT43PwkKaeokQMq8fjX1opz9WxHNXX6sh1dk6lOzitaU6F88Qqb0766SkrEbs6o=\\\\\\\"}\\\",\\\"security-sdk/s_sdk_sign_data_key/web_protect\\\":\\\"{\\\\\\\"data\\\\\\\":\\\\\\\"{\\\\\\\\\\\\\\\"ticket\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"hash.A4FTmlt9459W2VuCPaUVVJ1CAhsh11nKDmNpfQGDN8s=\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"ts_sign\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"ts.2.4353c5a2bf3e3f1a89491bf0369d9a90841ff96e22054ad9e6a34b38727cfb51c4fbe87d2319cf05318624ceda14911ca406dedbebeddb2e30fce8d4fa02575d\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"client_cert\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"pub.BDNjVF5GvCJIySeU+Kr7DkM0RT43PwkKaeokQMq8fjX1opz9WxHNXX6sh1dk6lOzitaU6F88Qqb0766SkrEbs6o=\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"log_id\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"20250912161339DA89C181ECAE78667992\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"create_time\\\\\\\\\\\\\\\":1757664820}\\\\\\\"}\\\",\\\"security-sdk/s_sdk_crypt_sdk\\\":\\\"{\\\\\\\"data\\\\\\\":\\\\\\\"{\\\\\\\\\\\\\\\"ec_privateKey\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"-----BEGIN PRIVATE KEY-----\\\\\\\\\\\\\\\\nMIGHAgEAMBMGByqGSM49AgEGCCqGSM49AwEHBG0wawIBAQQgZMBDKWhNwLe9Ev7x79WhQ4UCI3C7eESkvGL+kdxGmEihRANCAAQzY1ReRrwiSMknlPiq+w5DNEU+Nz8JCmnqJEDKvH419aKc/VsRzV1+rIdXZOpTs4rWlOhfPEKm9O+ukpKxG7Oq\\\\\\\\\\\\\\\\n-----END PRIVATE KEY-----\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"ec_publicKey\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"-----BEGIN PUBLIC KEY-----\\\\\\\\\\\\\\\\nMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEM2NUXka8IkjJJ5T4qvsOQzRFPjc/CQpp6iRAyrx+NfWinP1bEc1dfqyHV2TqU7OK1pToXzxCpvTvrpKSsRuzqg==\\\\\\\\\\\\\\\\n-----END PUBLIC KEY-----\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"ec_csr\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"\\\\\\\\\\\\\\\"}\\\\\\\"}\\\"}\",\"type\":1}"
        }
        const item = JSON.parse(res.body);
        const task = {
          ...res,
          body: { ...item, topic: item.topic ? JSON.parse(item.topic) : null },
          id: uuidv4(),
        }
        switch (task.method) {
          case 201:
            publishTask(task);
            setTaskId(prevTaskId => [...prevTaskId, item.id]);
            break;
          case 202:
            accountTask(task);
            break;
          case 203:
            videoTask(task);
            break;
          default:
            break;
        }
      }}>201</button> */}
      {version ? (
        <div className="global-version" onClick={handleOpenFolder}>
          当前版本：v{version}
        </div>
      ) : null}
      <Modal
        closeIcon={null}
        visible={
          ClientUpdate.promptly ||
          (ClientUpdate.isShow &&
            !Cookies.get("ClientSkip") &&
            !sessionStorage.getItem("next_update"))
        }
        footer={null}
        focusLock={false}
        style={{ width: 656, minHeight: 400 }}
      >
        <div className="client-update-box">
          <div className="update-header">
            <div className="header-info">
              <h1>发现新版本</h1>
              <p>V{ClientUpdate.updateInfo?.version}</p>
            </div>
          </div>
          <div className="update-content">
            <h2>更新功能：</h2>
            <div className="ul">
              {ClientUpdate.updateInfo?.update_content?.map((item, index) => (
                <div key={index} className="li">
                  <div className="circle">&emsp;</div>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="update-footer">
            {ClientUpdate.updateInfo?.is_mandatory_update ? (
              <></>
            ) : (
              <Button
                onClick={() => {
                  sessionStorage.setItem("next_update", ClientUpdate.version);
                  ClientUpdate.setIsShow(false);
                  ClientUpdate.setIsPromptly(false);
                }}
              >
                下次启动更新
              </Button>
            )}
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => {
                if (window.electron) {
                  let exe;
                  if (!checkAppleSystem()) {
                    exe = JSON.parse(
                      ClientUpdate.updateInfo.win_download_info
                    ).exe;
                  } else {
                    exe = JSON.parse(
                      ClientUpdate.updateInfo.mac_download_info
                    ).dmg;
                  }
                  window.electron.ipcRenderer.downloadUpdate({
                    url: exe.url,
                    isMandatory: ClientUpdate.updateInfo.is_mandatory_update,
                  });
                  ClientUpdate.setIsShow(false);
                  ClientUpdate.setIsPromptly(false);
                  setUpgradeVisible(true);
                }
              }}
            >
              立即更新
            </Button>
            {ClientUpdate.updateInfo?.is_mandatory_update ? (
              <></>
            ) : (
              <div
                className="skip"
                onClick={() => {
                  Cookies.set("ClientSkip", ClientUpdate.version, {
                    expires: 365,
                  });
                  ClientUpdate.setIsShow(false);
                  ClientUpdate.setIsPromptly(false);
                }}
              >
                <span style={{ paddingRight: 8 }}>跳过此版本</span>
                <IconDoubleRight />
              </div>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        closeIcon={null}
        visible={upgradeVisible}
        footer={null}
        focusLock={false}
        style={{ width: 400, minHeight: 227 }}
      >
        <div className="client-upgrade">
          <img src={upgrade} alt="" width={122} />
          <h1>客户端升级中</h1>
          <p>{progress}% 升级成功后会自动重启客户端 </p>
        </div>
      </Modal>
      <WSContext.Provider value={wsRef.current}>
        <ConfigProvider getPopupContainer={(node) => node.parentElement}>
          <RouterProvider router={router}></RouterProvider>
        </ConfigProvider>
      </WSContext.Provider>
    </div>
  );
}

export default observer(App);
